export interface Project { 
    id:number,
    name: string, 
    description: string, 
    total_events: number,
    total_events_created: number,
    dueDate: string, 
    csm: string, 
    status: string, 
    status_name: string, 
    additional_file_details:[] ,
    additional_files: []
    assign_to: number
    assign_to_name: string,
    assigned_to_group:  any
    assigned_to_group_name: any,
    client_name: string,
    contract_file_details: null
    contract_files: []
    project_progress:number
    created_at: string
    created_by:  number
    customer_success_manager:  number
    customer_success_manager_name: string
    customer_success_manager_image: string
    due_date: string
    link_details: null
    links: []
    modified_at: string
    modified_by:  number,
    project_client: number
    project_cost:number
    project_type:number
    project_type_name: string
    project_format: number
    project_format_name: string
    project_format_type: number
    project_format_type_name: string
    project_plan: string
    start_date:  string
    contact_type_name: string
    cancelled_reason:string
    closed_reason:string
    cancelled_closed_reason_str:string
    cancelled_reason_name:string
    closed_reason_name:string
}

export class ProjectResponseModel {
    count: number
    next: string
    previous: string
    results: Project[]
    initialValue: any
  }

export class ContactTypeList {
    id:number
    name:string
}

export class ContactTypeResponseModel {
    count:number
    next:string
    previous:string
    results: ContactTypeList[]
}

export class ProjectComment {
        id:number
        project_name:string	
        created_by_name:string
        modified_by_name	:string
        created_at:string	
        modified_at:string
        comment	:string
        created_by:number
        modified_by:number
        source_project:string
}


export class ProjectCommentResponseModel {
    count:number
    next:string
    previous:string
    results: ProjectComment[]
}

export class ProjectHistory {
    id: number
    text:string
    date: string
    by: string
}

export class ProjectHistoryResponse {
    count:number
    next:string
    previous:string
    results: ProjectHistory[]
}

export class ProjectFilter{
    id:number
    name:string
    project_format:number | number[]
    project_format_type:number | number[]
    status:number | number[]
    due_date:string
    customer_success_manager:number | number[]
}

export class StandardModel {
    id:number
    name:string
    slug:string
}

export class StandardResponseModel {
    count:number
    next:string
    previous:string
    results: StandardModel[]
}

 